// extracted by mini-css-extract-plugin
module.exports =  {"noPermission":"noPermission__hmiC1"};